import React from "react";

/**
 * SectionHead — consistent section title used across dashboards & lists.
 * Gold accent bar + serif title + optional actions on the right.
 */
export function SectionHead({ title, subtitle, actions, testId }) {
  return (
    <div className="flex items-end justify-between gap-3 flex-wrap mb-3" data-testid={testId}>
      <div className="flex items-center gap-2">
        <div className="w-1.5 h-6 bg-[#C9A24B] rounded-full" aria-hidden />
        <div>
          <h2 className="font-serif text-2xl font-medium leading-tight text-[#0F1E15]">{title}</h2>
          {subtitle && <div className="text-xs text-[#4A5A50] mt-0.5">{subtitle}</div>}
        </div>
      </div>
      {actions ? <div className="flex items-center gap-2 flex-wrap">{actions}</div> : null}
    </div>
  );
}

/**
 * PageHead — page-level title. Larger. Used above SectionHead groups.
 */
export function PageHead({ eyebrow, title, subtitle, actions, testId }) {
  return (
    <div className="flex items-end justify-between gap-3 flex-wrap" data-testid={testId}>
      <div>
        {eyebrow && (
          <div className="text-[10px] uppercase tracking-[0.3em] text-[#4A5A50]">{eyebrow}</div>
        )}
        <h1 className="font-serif text-4xl lg:text-5xl font-medium tracking-tight text-[#0F1E15] mt-1">
          {title}
        </h1>
        {subtitle && <p className="text-[#4A5A50] mt-1">{subtitle}</p>}
      </div>
      {actions ? <div className="flex items-center gap-2 flex-wrap">{actions}</div> : null}
    </div>
  );
}
